module.exports = __webpack_public_path__ + "static/media/harman.6f280acb.webp";